// import initSelectProduct from '../angle/modules/forms/select2';
import $, { isEmptyObject } from 'jquery';
import 'select2';
// Datatables
require('datatables.net-bs')
require('datatables.net-bs4/js/dataTables.bootstrap4.js')
require('datatables.net-bs4/css/dataTables.bootstrap4.css')
require('datatables.net-buttons')
require('datatables.net-buttons-bs')
require('datatables.net-responsive')
require('datatables.net-responsive-bs')
require('datatables.net-responsive-bs/css/responsive.bootstrap.css')
require('datatables.net-buttons/js/buttons.colVis.js') // Column visibility
require('datatables.net-buttons/js/buttons.html5.js') // HTML 5 file export
require('datatables.net-buttons/js/buttons.flash.js') // Flash file export
require('datatables.net-buttons/js/buttons.print.js') // Print view button
require('datatables.net-keytable');
require('datatables.net-keytable-bs/css/keyTable.bootstrap.css')
// $(document).ready(function () {
//   console.log('products javascript loaded admin side');
//   $("#discardProduct").on("click",'.discard-btn', function () {
//     var $sellerId = $(document).find('#admin-discard').attr("sellerId");
//     var $prodId = $(document).find('#admin-discard').attr("prodId");
//     var $content = $(this).parents(".reject-content");
//     $content.find(".loading-div").removeClass("hide");
//     $content.find(".main-buttons-row").addClass("hide");
//     console.log('initiate admin discard product',$content,$sellerId,$prodId);
//     $.ajax({
//       type: "PUT",
//       url: "/sellers/" + $sellerId + "/products/" + $prodId + "/discard",
//       success: function (result) {
//         $content.find(".loading-div").addClass("hide");
//         if (result.status == 200) {
//           $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
//           $content.find(".message-row .message").html(result.message);
//         } else {
//           $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
//           $content.find(".message-row .error").html(result.error);
//         }
//       },
//       error: function (result) {
//       }
//     });
//   });

//   $("#discardProduct").on("click", ".btn-confirm", function () {
//     window.location.href = "/products";
//   });
// });

function initDatatables() {
  if (!$.fn.DataTable) return;

  // Zero configuration

  $('#datatable1').DataTable({
    responsive: true,
    'paging': true, // Table pagination
    'ordering': false, // Column ordering
    'info': false, // Bottom left status text
    // Text translation options
    // Note the required keywords between underscores (e.g _MENU_)
    lengthChange: false,
    oLanguage: {
      sSearch: '<em class="fas fa-search"></em>',
      // sLengthMenu: '_MENU_ records per page',
      // info: 'Showing page _PAGE_ of _PAGES_',
      zeroRecords: 'Nothing found - sorry',
      infoEmpty: 'No records available',
      // infoFiltered: '(filtered from _MAX_ total records)',
      oPaginate: {
        sNext: '<em class="fa fa-caret-right"></em>',
        sPrevious: '<em class="fa fa-caret-left"></em>'
      }
    }
  });
}

export default initDatatables;

// $(function () {
//   initDatatables();
// });

// seller side
$(document).ready(function () {
  var urlParams = new URLSearchParams(window.location.search);
  var searchQuery = urlParams.get('search');

  if (searchQuery) {
    $(".searchprod-seller").val(decodeURIComponent(searchQuery));
  }
  $(".searchprod-seller").on("change", function () {
    var searchValue = $(this).val().trim(); // Get the value of the input and trim whitespace

    if (searchValue !== "") {
      var currentUrl = window.location.href.split('?')[0];
      console.log(currentUrl)
      window.location.href = currentUrl + "?search=" + encodeURIComponent(searchValue);
    }
    else {

      var currentUrl = window.location.href.split('?')[0];
      window.location.href = currentUrl;
    }
  });
  if ($(".new-product").length) {
    var on_edit = $(".new-product").find('.onedit').attr("value");
    var user_country = $(".new-product").find("#taxdetailtabs").attr("value")
    //set default user country tax
    $(document).find('.tax-detail-tab').each(function () {
      if ($(this).attr('value') === 'philippine_tax_rule' && user_country === 'philippines') {
        $(this).addClass('main')
      } else if ($(this).attr('value') === 'canada_tax_rule' && user_country === 'canada') {
        $(this).addClass('main')
      }
      if ($(this).hasClass('additional')) {
        $(this).removeClass('main')
      }
    })
    $(document).find('.tax-tab').each(function () {
      if (user_country === 'canada' && $(this).attr('value') === 'canada_tax_rule') {
        $(this).addClass('main')
      }
    })
    // if (user_country === 'philippines') {
    //   $(document).find('.tax-detail-tab.main').attr('value','philippine_tax_rule').addClass('main')
    //   $(document).fin
    // }
    // else if (user_country === 'canada') {
    //   $(document).find('.tax-detail-tab').attr('value','canada_tax_rule').addClass('main')
    // }
    var $curTab = "#product-info";
    //temporary fix on price conversion set default value to canada
    console.log("initiate set default currency origin")
    $(".new-product").find(".select-currency").val("canada");
    $(".new-product").find(".select-currency option[origin='Canada']").prop('selected', true);
    $(".new-product").find(".template-locations .location-container:not(.clone) .input-currency").val('Canada');
    $(".new-product").find(".template-locations .location-container:not(.clone) .currency-text").html('C$');

    $("input[name='product[mobile_number]']").on('keypress', function (e) {
      var phoneNumber = $(this).val();
      if (phoneNumber.length >= 11) {
        e.preventDefault();
        return false;
      }
    })
    $("select.province-select.canada").on("change", function () {
      var pickUpProvincePh = $(document).find("select.province-select.ph.hide");
      var valueCanada = $(this).val()
      if (pickUpProvincePh.val() === null || pickUpProvincePh.val() !== valueCanada) {
        pickUpProvincePh.val($(this).val())
        pickUpProvincePh.attr('value', $(this).val())
        var phOption = pickUpProvincePh.find('option[value="' + valueCanada + '"]');
        if (phOption.length === 0) {
          pickUpProvincePh.append($('<option>', {
            value: valueCanada,
            text: valueCanada,
            selected: true,
          }));
        } else {
          // Option exists, set it as selected
          phOption.prop('selected', true);
        }
        var option = pickUpProvincePh.find('option[value="' + valueCanada + '"]');
        option.attr('hidden')
        option.prop('hidden', true)
      }
    })
    $("select.province-select.ph").on("change", function () {
      var pickUpProvinceCanada = $(document).find("select.province-select.canada.hide");
      var valuePh = $(this).val()
      if (pickUpProvinceCanada.val() == null || pickUpProvinceCanada.val() != valuePh) {
        pickUpProvinceCanada.val($(this).val())
        pickUpProvinceCanada.attr('value', $(this).val())
        var canadaOption = pickUpProvinceCanada.find('option[value="' + valuePh + '"]');
        if (canadaOption.length === 0) {
          // Option doesn't exist, create it
          pickUpProvinceCanada.append($('<option>', {
            value: valuePh,
            text: valuePh,
            selected: true,
          }));

        } else {
          // Option exists, set it as selected
          canadaOption.prop('selected', true);
        }
        var option = pickUpProvinceCanada.find('option[value="' + valuePh + '"]');
        option.attr('hidden')
        option.prop('hidden', true)
      }
    })
    // on tax detail tab clicked
    $(".tax-detail-tab").on('click', function () {
      if ($(this).val() === 'philippine_tax_rule') {

      }
      else if ($(this).val() === 'main_tax_rule') {
        $(".tax-select").select2({
          theme: 'bootstrap4',
          disabled: false,
          placeholder: "Select Tax",
          templateResult: formatState
        });
      }
      else {
        var value = $(this).val()
        $(document).find('.tax-details .tax-tab').each(function () {
          if ($(this).val() === value) {
            $(this).addClass('main')
          }
          else {
            $(this).removeClass('main')
          }
        })
      }
    })
    $("input[name='product[mobile_number]']").on('change', function (e) {
      var phoneNumberPattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?|(^\+[1-9]\d{1,14}$)|(\d{9,14})$/;
      var errorElement = $('.error-message');
      var phoneNumber = $(this).val();
      var country = $('.new-product').find("#country_product_location").val();

      if (country == 'Canada') {
        phoneNumberPattern = /^(\+?1 ?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      } else {
        phoneNumberPattern = /^(09|\+639|639)\d{9}$/;
      }

      if (phoneNumberPattern.test(phoneNumber)) {
        // The phone number is valid
        errorElement.addClass("hide");
      } else {
        // The phone number is not valid
        errorElement.removeClass("hide");
      }
    })

    if ($("#select2-1").hasClass('canada')) {
      $(".delivery-select").select2({
        // theme: 'bootstrap4',
        placeholder: "Nationwide",
        disabled: true,
        // selectionCssClass: 'custom-select select2-disabled',
        selectionCssClass: 'select2-disabled',
        // templateResult: formatState,
        // templateSelection: formatSelection
      });
    }
    else {
      $(".delivery-select").select2({
        theme: 'bootstrap4',
        placeholder: "Select Area",
        // // selectionCssClass: 'custom-select',
        templateResult: formatState,
        templateSelection: formatSelection
      });
    }
    // // $(".select-category").select2({
    // //   theme: 'bootstrap4',
    // //   placeholder: "Select Category",
    // //   // templateResult: formatState
    // // });
    // //tax select 2 customize
    // function onCategory() {
    //   console.log('tax-select on category tax rule');
    //   // $(".tax-select").val($("#tax-category.tax-selected").val());
    //   // $(".tax-tab").val('category_tax_rule')
    // }
    // function onCanada() {
    //   $("#tax-canada-select").select2({
    //     theme: 'bootstrap4',
    //     placeholder: "CAN-01",
    //     disabled: true,
    //     selectionCssClass: 'select2-disabled',
    //     templateResult: formatState
    //   });
    //   // $(".tax-tab").val('canada_tax_rule')
    //   // $(".tax-select").val($("#tax-canada.tax-selected").val());
    // }
    // function onMain() {
    //   console.log('tax-select not on canada')

    //   $(".tax-select").select2({
    //     theme: 'bootstrap4',
    //     disabled: false,
    //     placeholder: "Select Tax",
    //     templateResult: formatState
    //   });
    //   // $(".tax-tab").val('main_tax_rule')
    //   // $(".tax-select").val($(".tax-selected").val());

    // }
    // $("#tax-category-tab").on("click", onCategory);
    // $("#tax-canada-tab").on("click", onCanada);
    // $("#tax-main-tab").on("click", onMain);
    // on add tax button clicked
    // $(document).on("keypress", '.removetax', function (e) {
    //   if (e.key === "Enter" || e.keyCode === 13) {
    //     e.preventDefault();
    //     console.log('disable enter')
    //   }
    // })
    $(document).on("click", '.removetax', function (e) {
      e.preventDefault()
      var taxcode = $(this).attr('value');
      $('.tax-detail-tabs .tax-detail-tab').each(function () {
        console.log($(this).html(), taxcode, $(this).html() === taxcode);
        if ($(this).attr('value') === taxcode) {
          $(this).remove()
          return;
        }
      })
      $('.tax-details .tax-tab').each(function () {
        if ($(this).attr('value') === taxcode) {
          $(this).remove()
          return;
        }
      })
      showToast('Tax rule successfully removed!', true, 3000, 'success');
    })
    $(document).on("click", ".addtax", function (e) {
      e.preventDefault()
      var taxcode = $(this).closest('.tax-tab').find('.tax-rule-value.code').html()
      var tabexists = false;
      //check if tax tab already exists
      $('.tax-detail-tabs .tax-detail-tab').each(function () {
        if ($(this).attr('value') === taxcode) {
          tabexists = true;
          return;
        }
      })
      if (tabexists) {
        //  alert('Tab already exists')
        showToast('Tax rule already added!', true, 3000, 'error'); // Show toast with timer for 3 seconds
      }
      else {
        var taxdetailstab = $('.tax-details').find('.tax-tab.main').clone()
        var labelElement = $('<label class="bold col-md-10 pd-0 col-form-label tax-rule-value code">' + taxcode + '</label>');
        var removetax = $("<button class='btn btn-danger removetax' type='button' taxid='" + $(this).attr('taxid') + "' value='" + taxcode + "'>Remove Tax</button>")
        var inputField = $("<input class='main-tax-id hide' name='tax_rules[][tax_rule_id]' value='" + $(this).attr('taxid') + "'></input><input class='hide' name='tax_rules[][is_category]' value=false></input>")
        taxdetailstab.appendTo('.tax-details');
        taxdetailstab.append(inputField)
        taxdetailstab.removeClass('main').attr("value", taxcode)
        taxdetailstab.find('select').replaceWith(labelElement)
        taxdetailstab.find('.addtax').replaceWith(removetax)

        taxdetailstab.find('input[name="tax_rules[][tax_rule_id]"]').attr('value', $(this).attr('taxid'));
        taxdetailstab.find('input[name="tax_rules[][tax_rule_id]"]').val($(this).attr('taxid')); //make sure payload is passing correct values
        //creating new tab
        var newTab = $('<div class="tax-detail-tab additional" value="' + taxcode + '">' + taxcode + '</div>')
        // Find the plus button tab and insert the new tab before it
        $('#tax-plus-tab').before(newTab);
        showToast('Tax rule added successfully!', true, 3000, 'success');
        return;
      }
    })
    //on load set tax details
    var tax_rule_id = $(".tax-select").val();
    if (tax_rule_id) {
      $.ajax({
        type: "GET",
        url: "/admins/tax_rules/" + tax_rule_id + ".json",
        success: function (result) {
          if (result.status == 200) {
            console.log('main tax triggered');
            var $taxRule = result.tax_rule;
            let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']");
            let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[value='main_tax_rule']");
            if ($taxRule) {
              $(".new-product").find(".main-tax-id").val($taxRule.id);
              $categoryTaxRuleTab.trigger("click");
              $.each($taxRule, function (key, val) {
                if ($categoryTaxRule.find("." + key).length > 0) {
                  $categoryTaxRule.find("." + key).html(val)
                }
              });
            }
            //create a add tax button
            var lastrow = $('.tax-tab.main').find('.last-tax-row')
            var button_container = lastrow.find(".add-tax-button-container")
            var hasbutton = button_container.children().length > 0;
            if (!hasbutton) {
              button_container.append("<button class='btn btn-info addtax' type='button' taxid='" + tax_rule_id + "'>Add Tax</button>")
            }
            else {
              button_container.find('.addtax').attr('taxid', tax_rule_id);
            }
          }
          else {
          }
        }
      });
    }
    $('.tax-select').on('change', function (e) {
      var data = $(this).val();
      // var data = e.params.data;
      // console.log('tax select fetch data', data)
      console.log("url: " + "/admins/tax_rules/" + $(".tax-select").val() + ".json")
      $.ajax({
        type: "GET",
        url: "/admins/tax_rules/" + data + ".json",
        success: function (result) {
          if (result.status == 200) {
            var $taxRule = result.tax_rule;
            let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']");
            let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[value='main_tax_rule']");
            if ($taxRule) {
              $(".new-product").find(".main-tax-id").val($taxRule.id);
              $categoryTaxRuleTab.trigger("click");
              $.each($taxRule, function (key, val) {
                if ($categoryTaxRule.find("." + key).length > 0) {
                  $categoryTaxRule.find("." + key).html(val)
                }
              });
            }
            //create a add tax button
            var lastrow = $('.tax-tab.main').find('.last-tax-row')
            var button_container = lastrow.find(".add-tax-button-container")
            var hasbutton = button_container.children().length > 0;
            if (!hasbutton) {
              button_container.append("<button class='btn btn-info addtax' type='button' taxid='" + data + "'>Add Tax</button>")
            }
            else {
              button_container.find('.addtax').attr('taxid', data);
            }
          }
          else {
          }
        }
      });
    });
    //end of tax select on change
    var city_arr = [];
    $(".template-locations .location-container").each(function () {
      console.log('template locations location-trigger');
      if ($(this).attr("city_name") != undefined) {
        city_arr.push($(this).attr("city_name"));
      }
    });
    //start of delivery-select
    $(".delivery-select").val(city_arr);
    if ($("#select2-1").hasClass('canada')) {
      onDeliverySelect($(".new-product"), "Nationwide");
    }
    //remove buttons on select2 delivery-selsect on load
    if ($('.delivery-select').length) {
      $(document).find('ul.select2-selection__rendered').remove();
    }

    $('.delivery-select').on('select2:select', function (e) {
      console.log('delivery selected')
      var data = e.params.data;
      if (data["title"] == "province") {
        $('.delivery-select option[title="' + data["text"] + '"]').each(function () {
          $(this).prop('selected', true);
          //differentiate by selected type
          if ($(this).hasClass('branches-select')) {
            console.log('trigger branches select')
            onDeliverySelect($(".new-product"), data["text"], data['type'] = 'branches');
          }
          else {
            console.log('trigger provinces select')
            onDeliverySelect($(".new-product"), data["text"], data['type'] = 'provinces');
          }
        });
        console.log("on delivery select :", $(this).attr("value"))
      }
      else {
        console.log("on delivery select else condition:", data["text"])
        if (data["text"] === 'Nationwide') {
          // $('.delivery-select').prop('disabled', true).addClass('disabled')
          // $('.select2-container').addClass('disabled')
          // $('.select2-container .select2-search--inline .select2-search__field').addClass('disabled')
          $(document).find('.template-locations').find('.location-container').each(function () {
            if ($(this).attr('city_name') !== 'Nationwide') {
              $(this).find('.trash').trigger('click');
            }
          })
        }

        //on delivery select process
        if ($(this).hasClass('branches-select')) {
          console.log('trigger branches select')
          onDeliverySelect($(".new-product"), data["text"], data['type'] = 'branches');
        }
        else {
          console.log('trigger provinces select')
          onDeliverySelect($(".new-product"), data["text"], data['type'] = 'provinces');
        }
      }
      $(document).find('ul.select2-selection__rendered').append("<li class='select2-selection__choice' title='" + data['title'] + "'>" + data['text'] + "</li>");
      $(document).find('li.select2-selection__choice').attr('title', data['title']).remove();
    });

    $('.delivery-select').on('select2:unselect', function (e, eventData) {
      var data = e.params === undefined ? eventData.params.data : e.params.data;
      console.log('data on unselect', data)
      if (data["text"] === 'Nationwide') {
        console.log('initate remove class disabled unselect nation wide ')
        $(".delivery-select").prop('disabled', false).removeClass('disabled')
        $('.select2-container').removeClass('disabled')
        $('.select2-container .select2-search--inline .select2-search__field').removeClass('disabled')
        $('.delivery-select option[title="' + data["text"] + '"]').each(function () {
          $(this).prop('selected', false);
        })
        console.log('if nationwide unselect enabled delivery select')
        onRemoveCity($('.cities-container').find(".city-locations .location-container[city_name='" + data["text"] + "']"), 'remove_region_ids[]', true);
      }
      else if (data["title"] == "province") {
        $('.delivery-select option[title="' + data["text"] + '"]').each(function () {
          $(this).prop('selected', false);
          onRemoveCity($(".new-product").find(".template-locations .location-container[city_name='" + $(this).attr("value") + "']"));
        });
      }
      else {
        onRemoveCity($(".new-product").find(".template-locations .location-container[city_name='" + data["text"] + "']"));
      }
      console.log('else remove prop', $(this))
      $(document).find('li.select2-selection__choice').attr('title', data['title']).remove();
    });
    $(".template-locations").on("click", '.location-container .trash', function () {

      var wanted_option = $('.delivery-select option[value="' + $(this).parents(".location-container").attr("city_name") + '"]');
      var cityName = wanted_option.text();
      var titleRegion = wanted_option.attr('title')
      var eventData = { params: { data: { selected: false, disabled: false, text: cityName, title: titleRegion } } };
      console.log('wanted option', wanted_option, wanted_option.attr('title'))
      if (wanted_option.attr('value') === 'Nationwide') {
        // Enable select input when Nationwide is deleted
        console.log('equals to nation wide trash')
        $(".delivery-select").prop('disabled', false).removeClass('disabled');
      }
      wanted_option.prop('selected', false);
      $(".delivery-select").trigger('select2:unselect', eventData);
      onRemoveCity($(this).parents(".location-container"), 'remove_city_ids[]', true);
      $(document).find('li.select2-selection__choice').attr('title', titleRegion).remove();
    })//end of delivery select 


    //delivery type select fields
    // var delivery_type = $('.delivery-type').val()
    // if (delivery_type === 'pick_up') {
    //   $('.not-branches-select').next('span.select2-container').addClass('hide');
    //   $('.branches-select').next('span.select2-container').removeClass('hide');
    // }
    // else {
    //   $('.not-branches-select').next('span.select2-container').removeClass('hide');
    //   $('.branches-select').next('span.select2-container').addClass('hide');
    // }
    // $('.delivery-type').on('change', function (e) {
    //   if (e.target.value == "pick_up") {
    //     $('.delivery-location-lbl').html('Pickup Location');
    //     $('.not-branches-select').next('span.select2-container').addClass('hide');
    //     $('.branches-select').next('span.select2-container').removeClass('hide');
    //   } else {
    //     $('.not-branches-select').next('span.select2-container').removeClass('hide');
    //     $('.branches-select').next('span.select2-container').addClass('hide');
    //     $('.delivery-location-lbl').html('Delivery Area');
    //   }
    // });


    $(".new-product").on("click", ".template-button", function () {
      $(".template-popup").show();
      $(".template-popup").css("height", $(document).height());
    });

    $(".template-popup").on("click", ".mask, button.close", function () {
      $(".template-popup").hide();
    });

    $(".template-popup").on("click", ".btn-use", function () {
      fetchTemplate($(this).parents(".table-container").attr("tempId"));
      $(".template-popup").hide();
    });

    $(".new-product").on("click", ".cities-container .trash", function () {
      var wanted_option = $('.delivery-select option[value="' + $(this).parents(".location-container").attr("city_name") + '"]');
      wanted_option.prop('selected', false);
      wanted_option.trigger('change');
      onRemoveCity($(this).parents(".location-container"));
    });

    let shipmentChecbox = $(".new-product .shipment-checkbox");
    $(".new-product").on("change", ".shipment-checkbox", function () {
      if ($(this).is(":checked")) {
        console.log(1)
        var $parent = $(".new-product");
        $parent.find(".prod-ship-length").val($parent.find(".prod-length").val());
        $parent.find(".prod-ship-width").val($parent.find(".prod-width").val());
        $parent.find(".prod-ship-height").val($parent.find(".prod-height").val());
        $parent.find(".prod-ship-weight").val($parent.find(".prod-weight").val());
        $parent.find(".prod-ship-weight-type").val($parent.find(".prod-weight-type").val());
        $parent.find(".shipment-weight-button").html($parent.find(".product-weight-button").html())

        var $shipment = $parent.find("#shipment-dd.dropdown-menu")
        $shipment.find("a").each(function () {
          var $parentz = $(this).parents(".dropdown");
          console.log($(this).attr("value"), $parent.find(".product-weight-button").html(), $parent.find(".product-weight-button").val(), $parent.find(".prod-weight-type").val())
          if ($(this).attr("value") === $parent.find(".prod-weight-type").val()) {
            console.log('hiding')
            $(this).addClass("hide");
          } else {
            $(this).removeClass("hide");
          }
        });
        var productUnitMeasure = $("#product-unit-measure").val()
        $("#shipment-unit-measure").val(productUnitMeasure)

        var productDimensionLabel = "Product Dimension: (L x W x H)  " + productUnitMeasure;
        $("#product-dimensions").text(productDimensionLabel);

        // Update shipment dimension label based on selected unit of measure
        var shipmentDimensionLabel = "Shipment Dimension: (L x W x H)  " + productUnitMeasure;
        $("#shipment-dimensions").text(shipmentDimensionLabel);
      }
    });
    $(".new-product").on("change", ".prod-width, .prod-length, .prod-height, .prod-weight", function () {
      let $this = $(this);
      if (shipmentChecbox.is(":checked")) {
        console.log(2)
        $(".new-product").find(".prod-ship-" + $this.attr("prodMeasure")).val($this.val());
      }
    });
    $(function () {
      function updateDimensionLabels() {
        var productUnitMeasure = $("#product-unit-measure").val()
        var shipmentUnitMeasure = $("#shipment-unit-measure").val()

        var productDimensionLabel = "Product Dimension: (L x W x H)  " + productUnitMeasure;
        $("#product-dimensions").text(productDimensionLabel);

        // Update shipment dimension label based on selected unit of measure
        var shipmentDimensionLabel = "Shipment Dimension: (L x W x H)  " + shipmentUnitMeasure;
        $("#shipment-dimensions").text(shipmentDimensionLabel);
      }
      updateDimensionLabels();
      $("select[name='product[unit_measure]']").on("change", updateDimensionLabels);
      $("select[name='product[shipment_unit_measure]']").on("change", updateDimensionLabels);
    })

    $(function () {
      var $selectBranch = $("#select_branch");
      if ($selectBranch.val() === "other") {
        // If it's "other," empty the input fields     
      }
      var sellerCountry = $("#country_product_location").val();
      var userCountry = $("#location-other").attr("country")

      $("#select_branch").on("change", function () {
        let $this = $(this);
        if ($this.val() == "other") {
          if ($('#location-other').hasClass('hide')) {
            $('#location-other').removeClass('hide')
          }
          $("#product_address_1").prop("readonly", false);
          $("#product_address_2").prop("readonly", false);
          $("#product_city").prop("readonly", false);
          $("#product_mobile").prop("readonly", false);
          $("#product_zip").prop("readonly", false);
          $("#product_province").attr("disabled", false);
          // $("#country_product_location").attr("disabled", false);

          $("#product_address_1").val(null).addClass("required")
          $("#product_address_2").val(null).addClass("required")
          $("#product_city").val(null).addClass("required")

          $("#product_zip").val(null).removeClass("required")
          $("#product_mobile").val(null).removeClass("required")
          $("#product_province").val(null).addClass("required")
          $("#country_product_location").val(sellerCountry).attr('value', sellerCountry).addClass("required");
        } else {
          if ($('#location-other').hasClass('hide')) {
            $('#location-other').removeClass('hide')
          }
          $("#product_address_1").val(null).removeClass("required")
          $("#product_address_2").val(null).removeClass("required")
          $("#product_city").val(null).removeClass("required")
          $("#product_province").val(null).removeClass("required")
          $("#product_zip").val(null).removeClass("required")
          $("#product_mobile").val(null).removeClass("required")
          $("#country_product_location").val(null).removeClass("required");

          $.ajax({
            type: "GET",
            url: "/sellers/branch/" + $this.val(),
            success: function (result) {
              console.log(result)
              $("#product_address_1").val(result.branch.address_1).attr('value', result.branch.address_1)
              $("#product_address_2").val(result.branch.address_2).attr('value', result.branch.address_2)
              $("#product_zip").val(result.branch.zip_code).attr('value', result.branch.zip_code)
              $("#country_product_location").val(result.branch.country).attr('value', result.branch.country)
              $("#country_product_location").trigger('change');
              var foundCountry = false;
              $(".country-option").each(function () {
                var $this = $(this);
                if (result.branch.country === $this.val()) {
                  $this.prop('selected', true);
                  foundCountry = true;
                }
              });
              if (!foundCountry) {
                $(document).find("#country_product_location").append("<option class='country-option' value='" + result.branch.country + "' selected='true'>" + result.branch.country + "</option>");
              }

              var foundProvince = false;
              $(".province-option").each(function () {
                var $this = $(this);
                if (result.branch.province === $this.attr("value")) {
                  $this.prop('selected', true);
                  foundProvince = true;
                }
              });
              if (!foundProvince) {
                $(document).find('#product_province').each(function () {
                  $(this).append("<option class='province-option' value='" + result.branch.province + "' selected='true'>" + result.branch.province + "</option>");
                })
              }
              $("#product_city").val(result.branch.city).attr('value', result.branch.city)
              $("#product_mobile").val(result.branch.mobile).attr('value', result.branch.mobile)
              $("#product_address_1").prop("readonly", true);
              $("#product_address_2").prop("readonly", true);
              $("#product_city").prop("readonly", true);
              $("#product_mobile").prop("readonly", true);
              $("#product_zip").prop("readonly", true);
              $("#product_province").attr("disabled", true);
              $("#country_product_location").attr("disabled", true);
            }
          });
        }
      })
    })

    //on load set provinces
    var productCountry = undefined;
    var $canadaProvincesSelect = $(".new-product").find('.province-select.canada');
    var $phProvincesSelect = $(".new-product").find('.province-select.ph');
    var country_value = $("select#country_product_location").val()
    if (country_value == "Canada") {
      $phProvincesSelect.addClass('hide');
      $canadaProvincesSelect.removeClass('hide');
      $("input[name='product[zip_code]']").attr('type', 'text');
    } else {
      $phProvincesSelect.removeClass('hide');
      $canadaProvincesSelect.addClass('hide');
      $("input[name='product[zip_code]']").attr('type', 'number');
    }


    $(".new-product").on("change", "#country_product_location", function () {
      var country = $(this).val();
      var $canadaProvincesSelect = $(".new-product").find('.province-select.canada');
      var $phProvincesSelect = $(".new-product").find('.province-select.ph');
      var phoneNumberField = $('input#product_mobile')
      productCountry = country;
      if (country == "Canada") {
        $phProvincesSelect.addClass('hide');
        $canadaProvincesSelect.removeClass('hide');
        $("input[name='product[zip_code]']").attr('type', 'text');
      } else {
        $phProvincesSelect.removeClass('hide');
        $canadaProvincesSelect.addClass('hide');
        $("input[name='product[zip_code]']").attr('type', 'number');
      }
      phoneNumberField.val('')
      // validatePhoneNumber($(".new-product").find("#main-form"), ".product-mobile");
    })
    on_edit = on_edit === 'false' ? false : true
    if (user_country === 'philippines' && !on_edit) {
      $('.select-origin').find('option').each(function () {
        console.log('initiate on load set product origin', $(this).val())
        if ($(this).val() === 'Philippines') {
          $(this).prop('selected', true)
          return
        }
      })
    }
    else if (user_country === 'canada' && !on_edit) {
      $('.select-origin').find('option').each(function () {
        console.log('initiate on load set product origin', $(this).val())
        if ($(this).val() === 'Canada') {
          $(this).prop('selected', true)
          return
        }
      })
    }
    // //set old
    // var counter = 0;
    // var old = []
    // $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab").each(function () {
    //   old[counter] = $(this)
    //   counter += 1;
    // })
    $(".new-product").on("change", ".select-origin", function () {
      $(".new-product").find(".select-currency option[origin='Canada']").prop('selected', true);
      $(".new-product").find(".template-locations .location-container:not(.clone) .input-currency").val('Canada');
      $(".new-product").find(".template-locations .location-container:not(.clone) .currency-text").html('Canada');
      // $(".new-product").find(".template-locations .location-container:not(.clone) .input-currency").val($(".new-product").find(".select-currency").val());
      // $(".new-product").find(".template-locations .location-container:not(.clone) .currency-text").html($(".new-product").find(".select-currency").val());
      //on change remove tax that does not belong to country selected

      //remove unrelated tax rules
      var origin_country = $(this).val()
      let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[is_category='true']");
      let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[is_category='true']");
      if ($categoryTaxRuleTab.attr("country") !== origin_country) {
        $categoryTaxRuleTab.addClass('hide');
        $categoryTaxRule.addClass('hide');
        $('.new-product').find('input#category-tax-id').val('no-value');
      }
      var select_category = $(".new-product").find(".select-category").val()
      var product_origin = $(".new-product").find(".select-origin").val()
      if (selectCategory.length > 0) {
        $.ajax({
          type: "GET",
          url: "/categories/fetch?id=" + select_category,
          success: function (result) {
            var $cat = result.category;
            let $taxRule = result.tax_rule;
            $(".new-product").find(".product-referral, .product-referral-hidden").val($cat.referral_fee);
            if ($taxRule && product_origin === $taxRule.origin_country) {
              $categoryTaxRuleTab.removeClass('hide');
              $categoryTaxRule.removeClass('hide');
              $categoryTaxRuleTab.attr('country', $taxRule.origin_country);
              $categoryTaxRule.attr('country', $taxRule.origin_country);
              $(".new-product").find(".category-tax-id").val($taxRule.id);
              $categoryTaxRuleTab.trigger("click");
              $.each($taxRule, function (key, val) {
                if ($categoryTaxRule.find("." + key).length > 0) {
                  $categoryTaxRule.find("." + key).html(val);
                }
              });
            }
            else {
              $categoryTaxRuleTab.addClass('hide');
              $categoryTaxRule.addClass('hide');
              $(".new-product").find(".category-tax-id").val("no-value");
              $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']").trigger("click");
              $categoryTaxRule.find(".tax-rule-value").html("");
            }
          }
        })
      }
    });
    //select category on load set category tax
    console.log(on_edit)
    if (!on_edit) {
      var selectCategory = $('.new-product').find('.select-category').first();
      if (selectCategory.length > 0) {
        $.ajax({
          type: "GET",
          url: "/categories/fetch?id=" + selectCategory.val(),
          success: function (result) {
            if (result.status == 200) {
              var $cat = result.category;
              $(".new-product").find(".product-referral, .product-referral-hidden").val($cat.referral_fee);
              let $taxRule = result.tax_rule;
              let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[is_category='true']");
              let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[is_category='true']");
              var lastrow = $categoryTaxRule.find('.last-tax-row')
              var button_container = lastrow.find(".add-tax-button-container")
              console.log('on load set category tax', $taxRule, user_country, $taxRule.origin_country === user_country)
              user_country = user_country === 'canada' ? 'Canada' : user_country === 'philippines' ? 'Philippines' : 'USA';
              if ($taxRule && $taxRule.origin_country === user_country) {
                console.log('category tax found')
                var removetax = $("<button class='btn btn-danger removetax' type='button' taxid='" + $taxRule.id + "' value='" + $taxRule.code + "'>Remove Tax</button>")
                $categoryTaxRuleTab.removeClass('hide')
                $categoryTaxRuleTab.html($taxRule.code);
                $categoryTaxRuleTab.val($taxRule.code)
                $categoryTaxRuleTab.attr('value', $taxRule.code)
                $categoryTaxRule.removeClass('hide')
                //if foudn set value on category tax so that if saved it will rettain that tax value
                $categoryTaxRule.find('#category-tax-id').val($taxRule.id);
                $categoryTaxRule.find('#category-tax-id').attr('value', $taxRule.id);
                $categoryTaxRule.attr('value', $taxRule.code);
                $categoryTaxRule.val($taxRule.code);
                $categoryTaxRule.attr('removable', true);
                button_container.append(removetax);
                $(".new-product").find(".category-tax-id").val($taxRule.id);
                $categoryTaxRuleTab.trigger("click");
                $.each($taxRule, function (key, val) {
                  if ($categoryTaxRule.find("." + key).length > 0) {
                    $categoryTaxRule.find("." + key).html(val)
                  }
                });
              } else {
                console.log('no category tax found')
                $categoryTaxRuleTab.addClass('hide')
                $categoryTaxRule.addClass('hide')
                $(".new-product").find(".category-tax-id").val(null);
                $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']").trigger("click");
                $categoryTaxRule.find(".tax-rule-value").html("");
              }
            }
          }
        });
      }
    }
    else {
      var selectCategory = $('.new-product').find('.select-category').val();
      var product_origin = $('.new-product').find('.select-origin').val();
      if (selectCategory.length > 0) {
        $.ajax({
          type: "GET",
          url: "/categories/fetch?id=" + selectCategory,
          success: function (result) {
            if (result.status == 200) {
              var $cat = result.category;
              $(".new-product").find(".product-referral, .product-referral-hidden").val($cat.referral_fee);
              let $taxRule = result.tax_rule;
              let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[is_category='true']");
              let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[is_category='true']");
              if ($taxRule && product_origin === $taxRule.origin_country) {
                console.log('category tax found on edit')
                $categoryTaxRuleTab.removeClass('hide')
                $categoryTaxRuleTab.html($taxRule.code)
                $categoryTaxRuleTab.val($taxRule.code)
                $categoryTaxRuleTab.attr('value', $taxRule.code)
                $categoryTaxRule.removeClass('hide')
                $categoryTaxRule.attr('removable', true);
                $categoryTaxRule.attr('value', $taxRule.code);
                $categoryTaxRule.val($taxRule.code);
                $categoryTaxRule.find('.removetax').attr('taxid', $taxRule.id);
                $categoryTaxRule.find('.removetax').attr('value', $taxRule.code);
                $categoryTaxRule.find('.removetax').attr('type', "button");
                $categoryTaxRule.find('.removetax').val($taxRule.code);
                $categoryTaxRuleTab.attr('country', $taxRule.origin_country)
                $categoryTaxRule.attr('country', $taxRule.origin_country)
                $(".new-product").find(".category-tax-id").val($taxRule.id);
                $categoryTaxRuleTab.trigger("click");
                $.each($taxRule, function (key, val) {
                  if ($categoryTaxRule.find("." + key).length > 0) {
                    $categoryTaxRule.find("." + key).html(val)
                  }
                });
              } else {
                console.log('no category tax found on edit')
                $categoryTaxRuleTab.addClass('hide')
                $categoryTaxRule.addClass('hide')
                $(".new-product").find(".category-tax-id").val(null);
                $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']").trigger("click");
                $categoryTaxRule.find(".tax-rule-value").html(null);
              }
            }
          }
        });
      }
    }
    //select category on change set tax
    $(".new-product").on("change", ".select-category", function () {
      console.log('select category on change', $(this).val())
      $.ajax({
        type: "GET",
        url: "/categories/fetch?id=" + $(this).val(),
        success: function (result) {
          if (result.status == 200) {
            var $cat = result.category;
            $(".new-product").find(".product-referral, .product-referral-hidden").val($cat.referral_fee);
            let $taxRule = result.tax_rule;
            let $categoryTaxRuleTab = $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[is_category='true']");
            let $categoryTaxRule = $(".new-product").find(".tax-info .tax-details .tax-tab[is_category='true']");
            var country = user_country === 'philippines' ? 'Philippines' : 'Canada'
            if ($categoryTaxRuleTab && $categoryTaxRule) {
              console.log('category tax div found');
              if ($taxRule && $taxRule.origin_country === country) {
                $categoryTaxRuleTab.removeClass('hide')
                $categoryTaxRule.removeClass('hide')
                $categoryTaxRule.val($taxRule.code);
                $categoryTaxRule.find('.removetax').attr('taxid', $taxRule.id);
                $categoryTaxRule.find('.removetax').attr('value', $taxRule.code);
                $categoryTaxRule.find('.removetax').attr('type', "button");
                $categoryTaxRule.find('.removetax').val($taxRule.code);
                $categoryTaxRule.attr("value", $taxRule.code);
                $categoryTaxRuleTab.val($taxRule.code)
                $categoryTaxRuleTab.html($taxRule.code)
                $categoryTaxRuleTab.attr('value', $taxRule.code)
                $(".new-product").find(".category-tax-id").val($taxRule.id);
                $categoryTaxRuleTab.trigger("click");
                // $categoryTaxRule.removeClass("hide");
                $.each($taxRule, function (key, val) {
                  if ($categoryTaxRule.find("." + key).length > 0) {
                    $categoryTaxRule.find("." + key).html(val)
                  }
                });
              }
              else {
                $categoryTaxRuleTab.addClass('hide')
                $categoryTaxRule.addClass('hide')
                $(".new-product").find(".category-tax-id").val("no-value");
                $(".new-product").find(".tax-info .tax-detail-tabs .tax-detail-tab[value='main_tax_rule']").trigger("click");
                // $categoryTaxRuleTab.addClass("hide");
                // $categoryTaxRule.addClass("hide");
                $categoryTaxRule.find(".tax-rule-value").html("");
              }

            }
            else {
              if ($taxRule) {
                console.log('no category tax div element found')
                var taxcode = $taxRule.code
                var taxdetailstab = $('.tax-details').find('.tax-tab.main').clone()
                var labelElement = $('<label class="bold col-md-10 pd-0 col-form-label tax-rule-value code">' + taxcode + '</label>');
                var removetax = $("<button class='btn btn-danger removetax' type='button' taxid='" + $taxRule.id + "' value='" + taxcode + "'>Remove Tax</button>")
                var inputField = $("<input class='main-tax-id hide' name='tax_rules[][tax_rule_id]' value='" + $taxRule.id + "'></input><input class='hide' name='tax_rules[][is_category]' value=false></input>")
                taxdetailstab.appendTo('.tax-details');
                taxdetailstab.append(inputField)
                taxdetailstab.removeClass('main').attr("value", taxcode)
                taxdetailstab.find('select').replaceWith(labelElement)
                taxdetailstab.find('.addtax').replaceWith(removetax)
                taxdetailstab.find('input[name="tax_rules[][tax_rule_id]"]').attr('value', $taxRule.id);
                taxdetailstab.find('input[name="tax_rules[][tax_rule_id]"]').val($taxRule.id); //make sure payload is passing correct values
                //creating new tab
                var newTab = $('<div class="tax-detail-tab additional" value="' + taxcode + '" is_category=' + $taxRule.is_category + '>' + taxcode + '</div>')
                // Find the plus button tab and insert the new tab before it
                $('#tax-plus-tab').before(newTab);
              }
            }
          }
        }
      });
    });

    $(".new-product").on("click", ".tax-info .tax-detail-tabs .tax-detail-tab", function () {
      let $this = $(this);
      let taxInfo = $(".tax-info");
      taxInfo.find(".tax-detail-tabs .tax-detail-tab").removeClass("main");
      $this.addClass("main");

      taxInfo.find(".tax-details .tax-tab").removeClass("main");
      taxInfo.find(".tax-details .tax-tab[value='" + $this.attr("value") + "']").addClass("main");
    });

    var $drafProdId = null;
    $(".new-product").on("click", ".btn-draft", function (e) {
      e.preventDefault();
      var $product = $(".new-product");
      var $form = $product.find("#main-form");
      var counter = 0
      // differentiate tax rules
      $('input[name="tax_rules[][tax_rule_id]"]').each(function () {

        counter++
      })
      var totaltaxcount = counter;
      counter = 0;
      var taxRuleIds = [];
      $('input[name="tax_rules[][tax_rule_id]"]').each(function () {
        // if (counter === totaltaxcount) {
        //   $(this).remove();
        //   return
        // }
        if (taxRuleIds.includes($(this).attr('value'))) {
          $(this).remove();
        } else {
          $(this).val($(this).attr('value'))
          taxRuleIds.push($(this).attr('value'))
        }
        // $(this).attr('name', "tax_rules[][tax_rule_id][" + counter + "]")
        counter++
      })
      //product name required to save as draft
      var isValid = validateFields($form, ".draft-inputs.product-name", true);

      if (isValid) {
        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row, .message, .error").addClass("hide");
        $('#loadingModal').find(".error, .message").html("");
        // $('#loadingModal').modal('show');
        $("button.loading-btn").click();


        $.ajax({
          type: "POST",
          url: "/sellers/products/save_as_draft",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);

              $('.new-product').find(".image-info .row.product-row.image:not(.clone, .tabs)").each(function (index) {
                var $imageRow = $(this);

                if ($imageRow.find(".image").attr("src") != "/assets/no-image.png") {
                  if ($imageRow.attr('image_id')) {
                  } else {
                    $imageRow.attr('image_id', result.image_ids[index]);
                  }
                }
              });

              if (result.product_id != undefined) {
                $drafProdId = result.product_id
              }
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.error);
            }
          }
        });
      }
      else {
        $(".new-product").find("#main-form.tab-content " + $curTab).removeClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active");

        $curTab = $errorTab;
        $(".new-product").find("#main-form.tab-content " + $curTab).addClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").addClass("active");

        checkButtons($(".new-product"));
      }
    });

    $(".new-product").on("click", ".btn-update", function (e) {
      e.preventDefault();
      console.log('initiate update product')
      $('.new-product').find("input[name='tax_rules[][tax_rule_id]']").each(function () {
        $(this).val($(this).attr('value'))
      })
      var $product = $(".new-product");
      var $form = $product.find("#main-form");
      var isValid = validateFields($form, ".required");
      if (isValid) {
        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row, .message, .error").addClass("hide");
        $('#loadingModal').find(".error, .message").html("");
        // $('#loadingModal').modal('show');
        $("button.loading-btn").click();
        $.ajax({
          type: "POST",
          url: "/sellers/products/update",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.error);
            }
          }
        });
      }
      else {
        $(".new-product").find("#main-form.tab-content " + $curTab).removeClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active");

        $curTab = $errorTab;
        $(".new-product").find("#main-form.tab-content " + $curTab).addClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").addClass("active");

        checkButtons($(".new-product"));
      }
    });

    $(".new-product").on("click", ".btn-save", function (e) {
      e.preventDefault();
      var $product = $(".new-product");
      var $form = $product.find("#main-form");
      var isValid = validateFields($form, ".required");

      if ($product.find(".has-inventory").attr("value") == "false") {
        $('#loadingModal').find(".loading-row").addClass("hide");
        $('#loadingModal').find(".message-row, .button-row, .message, .error").addClass("hide");
        $('#loadingModal').find(".error, .message").html("");
        $('#loadingModal').find(".message-row, .error, .button-row").removeClass("hide");
        $('#loadingModal').find(".error").html("Product can not be released yet since it doesn't have an inventory.");
        $("button.loading-btn").click();
      }
      else if (isValid) {
        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row, .message, .error").addClass("hide");
        $('#loadingModal').find(".error, .message").html("");
        // $('#loadingModal').modal('show');
        $("button.loading-btn").click();


        $.ajax({
          type: "POST",
          url: "/sellers/products/release",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row, .btn-confirm").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row, .btn-redirect").removeClass("hide");
            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.error);
            }
          }
        });
      }
      else {
        $(".new-product").find("#main-form.tab-content " + $curTab).removeClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active");

        $curTab = $errorTab;
        $(".new-product").find("#main-form.tab-content " + $curTab).addClass("active");
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").addClass("active");

        checkButtons($(".new-product"));
      }
    });

    $("#loadingModal").on("click", ".btn-redirect", function () {
      window.location.href = "/products";
    });
    $('#loadingModal').on("click", ".btn-reload", function () {
      window.location.reload();
    });

    $("#loadingModal").on("click", ".btn-confirm", function () {
      if ($drafProdId != null) {
        window.location.href = "/products/" + $drafProdId + "/edit";
      }
    });

    $(".new-product").on("click", ".list-group .list-group-item", function () {
      $curTab = $(this).attr("href");
      checkButtons($(".new-product"));
    });

    $(".new-product").on("click", ".btn-next", function (e) {
      $(".new-product").find("#main-form.tab-content " + $curTab).removeClass("active");
      $(".new-product").find("#main-form.tab-content " + $curTab).next().addClass("active");

      var $next = $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").next();
      if ($next.length) {
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active");
        $next.addClass("active");
        $curTab = $next.attr("href");
      }
      checkButtons($(".new-product"));
    });

    $(".new-product").on("click", ".btn-back:not(.disabled)", function (e) {
      $(".new-product").find("#main-form.tab-content " + $curTab).removeClass("active");
      $(".new-product").find("#main-form.tab-content " + $curTab).prev().addClass("active");

      var $prev = $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").prev();
      if ($prev.length) {
        $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active");
        $prev.addClass("active");
        $curTab = $prev.attr("href");
      }
      checkButtons($(".new-product"));
    });

    $(".image-info").on("click", ".add-image-row", function () {
      $(this).addClass("hide");
      var $parent = $(this).parents(".product-row");
      $parent.find(".btn-danger").removeClass("hide");

      var $image = $(".image-info").find(".row.product-row.clone").clone();
      $image.removeClass("clone hide");
      $image.appendTo($(".image-info"));

      if ($(".image-info .row.product-row.image:not(.clone)").length >= 9) {
        $image.find(".add-image-row").addClass("hide");
      }
    });

    $(".image-info").on("click", ".remove-image-row", function () {
      $(this).addClass("hide");
      var $parent = $(this).parents(".product-row");
      if ($parent.is(':last-child')) {
        $parent.prev().find(".add-image-row").addClass("hide");
        $parent.prev().find(".remove-image-row").removeClass("hide");
      }
      if ($parent.attr("image_id") != "" || $parent.attr("image_id") != undefined) {
        $('<input>').attr({
          type: 'hidden',
          name: 'remove_image_ids[]',
          value: $parent.attr("image_id")
        }).appendTo($(".remove-ids-container"));
      }
      $parent.remove();
      var $nextRow = $(".image-info .row.product-row.image:not(.clone, .tabs)").first();

      if ($nextRow.find('.image-container .image').attr('src').indexOf('add-image') === -1) {
        $nextRow.find('.form-check-input').prop('checked', true);
      }
      $(".image-info .row.product-row.image").last().find(".add-image-row").removeClass("hide");
    });

    $(".image-info").on("click", ".product-row.video .remove-prod-video", function () {
      var $parent = $(this).parents(".product-row.video");
      $parent.find(".video-container").html("").addClass("hide");
      $parent.find(".upload-video").val(null);
      $parent.find("#delete_video").val("true");
      $parent.find(".image-container").removeClass("hide");
    });

    $(".image-info").on("click", ".product-row .image, .product-row .change-image-container", function () {
      $(this).parents(".col-image").find(".upload-image").click();
    });

    $(".image-info").on("click", ".product-row.video .image, .product-row.video .change-image-container", function () {
      $(this).parents(".col-image").find(".upload-video").click();
    });

    $(".image-info").on("change", ".product-row .upload-image", function () {
      if (checkFileSize(this, 20)) {

        $('#loadingModal').find(".loading-row").addClass("hide");
        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $('#loadingModal').find(".error").removeClass("hide").html("Image/Video file must be less than 20mb");
        $("button.loading-btn").click();
        $(this).val("");
      }
      else if ($(this).val() != "") {
        readURL(this, $(this).parents(".col-image").find(".image"));

        var $parent = $(this).parents(".product-row");
        if ($parent.is(':last-child')) {
          // $parent.prev().find(".add-image-row").addClass("hide");
          $parent.find(".remove-image-row").removeClass("hide");
        }
      }
    });

    $(".image-info").on("change", ".product-row .upload-video", function () {
      console.log("uploading video")
      if (checkFileSize(this, 20)) {
        $('#loadingModal').find(".loading-row").addClass("hide");
        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
        $('#loadingModal').find(".message, .error").addClass("hide").html("");
        $('#loadingModal').find(".error").removeClass("hide").html("Image/Video file must be less than 20mb");
        $("button.loading-btn").click();
        var $parent = $(this).parents(".product-row.video");
        $parent.find(".video-container").html("").addClass("hide");
        $parent.find(".upload-video").val(null);
        $parent.find("#delete_video").val("true");
        $parent.find(".image-container").removeClass("hide");
      } else {
        $(this).parents(".col-image").find(".image-container").addClass("hide");
        readURL(this, $(this).parents(".col-image").find(".video-container"), true);
      }
    });
    // change and convert value
    $(".new-product").on("click", ".product-weight-button", function (e) {
      var $parent = $(this).parents(".dropdown");
      $parent.find(".dropdown-menu").toggleClass("show");
    });

    $(".new-product").on("click", "#product-dd.dropdown-menu a", function (e) {
      var $parent = $(this).parents(".dropdown");
      var weightTypeInputField = $(document).find("input[name='product[weight_type]']")
      var weightValueInputField = $(document).find("input[name='product[weight]']")
      var weightValue = $(document).find("input[name='product[weight]']").val()
      //hide selected weight type
      var selectedWeightType = $(this).attr("value");
      $parent.find(".dropdown-menu a").each(function () {
        if ($(this).attr("value") === selectedWeightType) {
          $(this).addClass("hide");
        } else {
          $(this).removeClass("hide");
        }
      });
      $parent.find(".dropdown-menu").removeClass("show");
      $parent.find(".product-weight-button").html($(this).html());
      $parent.find("input").val($(this).attr("value"));
      weightTypeInputField.attr("value", $(this).attr("value"))
      var type = $(this).attr("value")
      if (weightValue.length > 0 && weightValue != undefined) {
        if (type == 'lbs') {
          var weightInLb = (weightValue * 2.2).toFixed(2)
          weightValueInputField.val(weightInLb)
        }
        else if (type == 'kgs') {
          var weightInKg = (weightValue / 2.2).toFixed(2)
          weightValueInputField.val(weightInKg)
        }
      }
    });
    $(".new-product").on("click", ".shipment-weight-button", function (e) {
      var $parent = $(this).parents(".dropdown");
      $parent.find(".dropdown-menu").toggleClass("show");
    });

    $(".new-product").on("click", "#shipment-dd.dropdown-menu a", function (e) {
      var weightTypeInputField = $(document).find("input[name='product[shipment_weight_type]']")
      var weightValueInputField = $(document).find("input[name='product[shipment_weight]']")
      var weightValue = $(document).find("input[name='product[shipment_weight]']").val()
      //hide selected weight type
      var $parent = $(this).parents(".dropdown");
      $parent.find(".dropdown-menu").removeClass("show");
      weightTypeInputField.attr("value", $(this).attr("value"))
      var type = $(this).attr("value")
      var selectedWeightType = $(this).attr("value");
      $parent.find(".dropdown-menu a").each(function () {
        if ($(this).attr("value") === selectedWeightType) {
          $(this).addClass("hide");
        } else {
          $(this).removeClass("hide");
        }
      });
      $parent.find(".shipment-weight-button").html($(this).html());
      $parent.find("input").val($(this).attr("value"));
      if (weightValue.length > 0 && weightValue != undefined) {
        if (type == 'lbs') {
          var weightInLb = (weightValue * 2.2).toFixed(2)
          weightValueInputField.val(weightInLb)
        }
        else if (type == 'kgs') {
          var weightInKg = (weightValue / 2.2).toFixed(2)
          weightValueInputField.val(weightInKg)
        }
      }
    });

    $(".new-product").on("click", ".btn-preview", function (e) {
      var $popup = $("#previewProductModal");
      var $parent = $(".new-product");
      var user_country = $(".new-product").find("#taxdetailtabs").attr("value")
      user_country = user_country === 'philippines' ? 'Philippines' : 'Canada'
      $popup.find(".product-name").html($parent.find(".product-name").val());
      $popup.find(".product-description").html($parent.find(".product-description").val());
      $popup.find(".product-manufacturer").html($parent.find(".product-manufacturer").val());
      $popup.find(".product-unique").html($parent.find(".product-unique").val());
      $popup.find(".product-price-value").html($parent.find(".product-price").val());
      $popup.find(".currency").html($parent.find(".select-currency").val());
      $popup.find(".prod-origin").html($parent.find(".select-origin").val());
      $popup.find(".ships-from").html(user_country);
      $popup.find(".product-item-no").html($parent.find(".product-item-no").val());
      $popup.find(".prod-weight").html($parent.find(".prod-weight").val() + " " + $parent.find(".prod-weight-type").val());

      var prodDimensions = $parent.find(".prod-length").val() + " x " + $parent.find(".prod-width").val() + " x " + $parent.find(".prod-height").val() + " inches";
      $popup.find(".prod-dimensions").html(prodDimensions);

      var mainImageUrl = "";
      var videoURL = "";
      var imageUrls = [];
      var videoURLIndex = undefined;
      $popup.find(".main-images-container, .sub-images-container").html("");
      $parent.find(".image-info .row.product-row:not(.clone, .tabs)").each(function (index) {
        var $imageRow = $(this);
        var hasVideo = $imageRow.find('.image-container').hasClass('hide');
        var hasImage = $imageRow.find('.image-container .image').attr("src").indexOf('add-image') === -1;

        if (($imageRow.hasClass('video') && hasVideo) || hasImage) {
          if ($(this).find(".form-check-input").is(':checked')) {
            mainImageUrl = $imageRow.find(".image").attr("src");
          }
          else {
            videoURL = $imageRow.find('source').attr("src");

            if (videoURL) {
              if (videoURLIndex == undefined) {
                videoURLIndex = index;
                imageUrls.push(videoURL);
              }
            } else {
              if (hasImage && $imageRow.find('.image-container .image').attr("src").indexOf('no-video') === -1) {
                imageUrls.push($imageRow.find(".image").attr("src"));
              }
            }
          }
        }
      });

      if (mainImageUrl === '') {
        if (videoURL != '' && videoURLIndex !== undefined) {
          mainImageUrl = videoURL
          videoURLIndex = undefined
          imageUrls.splice(videoURLIndex, 1);
          setPreviewImage($popup, videoURL, 1, true, true);
        }
      } else {
        setPreviewImage($popup, mainImageUrl, 1, true);
      }

      var ctr = 2;

      $.each(imageUrls, function (ind, url) {
        if (ind == videoURLIndex) {
          setPreviewImage($popup, url, ctr, false, true);
        } else {
          setPreviewImage($popup, url, ctr);
        }

        ctr++;
      });
    });

    $(".new-product").on("click", ".btn-unpublish", function () {
      $("#unpublishProduct").find(".modal-title").html("UNPUBLISH PRODUCT");
      $("#unpublishProduct").find(".unpublish-btn, .unpublish-question, .question-row").removeClass("hide");
      $("#unpublishProduct").find(".publish-btn, .publish-question").addClass("hide");
      $("#unpublishProduct").find(".unpublish-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#unpublishProduct").find(".unpublish-btn").attr("prodId", $(this).attr("prodId"));
    });

    $(".new-product").on("click", ".btn-publish", function () {
      $("#unpublishProduct").find(".modal-title").html("PUBLISH PRODUCT");
      $("#unpublishProduct").find(".unpublish-btn, .unpublish-question").addClass("hide");
      $("#unpublishProduct").find(".publish-btn, .publish-question, .question-row").removeClass("hide");
      $("#unpublishProduct").find(".publish-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#unpublishProduct").find(".publish-btn").attr("prodId", $(this).attr("prodId"));
    });

    $('.new-product').on('keypress', '.prod-order-limit, .product-price, .prod-ship-weight, .prod-weight, .product-postal[type=number]', function (e) {
      console.log(e.which)
      if (e.which != 8 && e.which != 0 && e.which != 47 && e.which < 46 || e.which > 57) {
        e.preventDefault();
      }
    });
    $('input[name="product[order_limit]"]').on('keypress', function (e) {
      if (e.key === '.') {
        e.preventDefault();
      }
    });
    $("#unpublishProduct").on("click", ".unpublish-btn", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      var $content = $(this).parents(".reject-content");
      $content.find(".loading-div").removeClass("hide");
      $content.find(".main-buttons-row").addClass("hide");
      $.ajax({
        type: "PUT",
        url: "/sellers/" + $sellerId + "/products/" + $prodId + "/unpublish",
        success: function (result) {

          $content.find(".loading-div, .question-row").addClass("hide");
          if (result.status == 200) {
            $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $content.find(".message-row .message").html(result.message);
          }
          else {
            $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
            $content.find(".message-row .error").html(result.error)
          }
        },
        error: function (result) {
        }
      });
    });

    $("#unpublishProduct").on("click", ".publish-btn", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      var $content = $(this).parents(".reject-content");
      var $isValid = false;
      var $form = $(".new-product.edit-product").find("#main-form");
      var areFieldsValid = validateFields($form, ".draft-inputs");
      $content.find(".loading-div").removeClass("hide");
      $content.find(".main-buttons-row").addClass("hide");
      $content.find(".loading-row").addClass("hide");
      $isValid = checkImagesOnEdit($form, $isValid)
      if ($isValid && areFieldsValid) {
        $content.find(".message-row, .error, .main-buttons-row").addClass("hide");
        var $product = $(".new-product.edit-product");
        var $form = $product.find("#main-form");
        $.ajax({
          type: "POST",
          url: "/sellers/products/save_as_draft",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              if (result.product_id != undefined) {
                $drafProdId = result.product_id
              }
              $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/products/" + $prodId + "/publish",
                success: function (result) {

                  $content.find(".loading-div").addClass("hide");
                  if (result.status == 200) {
                    $("#unpublishProduct").find(".publish-btn, .publish-question").addClass("hide");
                    $content.find(".publish-question").addClass('hide');
                    $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
                    $content.find(".message-row .message").html(result.message);
                  }
                  else {

                    $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                    $content.find(".message-row .error").html(result.error)
                  }

                },
                error: function (result) {
                }
              });
            }
            else {
              // $('#loadingModal').find(".error").removeClass("hide").html(result.error);
            }
          }
        });
      }
      else {
        $content.find(".loading-row").addClass("hide");
        if (!areFieldsValid) {
          $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
          $content.find(".message-row .error").attr('style', 'font-size:20px;').html("Please fill in the required fields with valid input/format. Thank you.");
          $content.find(".loading-div").addClass("hide");

          $curTab = $errorTab;
          console.log('error tab', $curTab)
          // $(".new-product").find("#main-form.tab-content").find(".active").removeClass("active");
          // $(".new-product").find(".list-group").find(".active.error").removeClass("active error");
          $(".new-product").find(".list-group .list-group-item[href='" + $curTab + "']").addClass("active error");
          // $(".new-product").find("#main-form.tab-content " + $curTab).addClass("active");
          checkButtons($(".new-product"));
        } else {
          $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
          $content.find(".message-row .error").html('afterend', "<div class='error'>Must have at least one(1) image uploaded</div>");
          $content.find(".loading-div").addClass("hide");
          $curTab = $errorTab;
          // $(".new-product.edit-product").find("#main-form.tab-content " + $curTab).removeClass("active");
          // $(".new-product.edit-product").find(".list-group .list-group-item[href='" + $curTab + "']").removeClass("active"); 
          // $(".new-product.edit-product").find("#main-form.tab-content " + $curTab).addClass("active");
          // $(".new-product.edit-product").find(".list-group .list-group-item[href='" + $curTab + "']").addClass("active");
          $(".new-product.edit-product").find(".list-group .list-group-item[href='#images']").addClass("error");
          $form.find(".image-info .error-message").removeClass("hide");
          $form.find(".image-info .error-message").html("Must have at least one(1) image uploaded");
          checkButtons($(".new-product.edit-product"));
        }
      }
    });

    $("#unpublishProduct").on("click", ".btn-confirm", function () {
      window.location.reload();
    });

    $(".new-product").on("click", ".btn-discard", function () {
      $("#discardProduct").find(".discard-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#discardProduct").find(".discard-btn").attr("prodId", $(this).attr("prodId"));
    });

    $("#discardProduct").on("click", ".discard-btn", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      var $content = $(this).parents(".reject-content");
      $content.find(".loading-div").removeClass("hide");
      $content.find(".main-buttons-row").addClass("hide");
      $.ajax({
        type: "PUT",
        url: "/sellers/" + $sellerId + "/products/" + $prodId + "/discard",
        success: function (result) {

          $content.find(".loading-div").addClass("hide");
          if (result.status == 200) {
            $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $content.find(".message-row .message").html(result.message);
          }
          else {
            $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
            $content.find(".message-row .error").html(result.error)
          }
        },
        error: function (result) {
        }
      });
    });

    $("#discardProduct").on("click", ".btn-confirm", function () {
      window.location.href = "/products";
    });

    var $errorTab = "";
    function validateFields(parent, section, isProductName = false) {
      var isValid = true;
      $errorTab = "";
      $(".new-product").find(".list-group .list-group-item").removeClass("error");

      parent.find("input" + section).each(function (e) {
        if ($(this).parents(".clone").length == 0) {
          var $row = $(this).parents(".dimensions").length > 0 ? $(this).parents(".dimensions") : $(this).parents(".row.product-row");
          $(this).removeClass("error-input");
          var value = $(this).val();
          if (value == "") {
            if ($errorTab == "") {
              $errorTab = $(this).attr("curTab");
            }
            $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");

            isValid = false;
            $(this).addClass("error-input");

            $row.find(".error-message").html("This field must not be empty");
          }
          // else {
          //   console.log('hide error message 1')
          //   $row.find(".error-message").addClass("hide");
          //   $row.find(".error-message").html("");
          // }
        }
      });

      if (isProductName) {
        return isValid;
      }

      isValid = checkImages(parent, isValid);
      isValid = checkUnitCost(parent, isValid);
      if (parseFloat($(".new-product").find(".input-group.weight .prod-weight").val()) <= 0) {
        isValid = false;
        $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
        $errorTab = "#product-info";
        $(".new-product").find(".input-group.weight .prod-weight").addClass("error-input");
        $(".new-product").find(".input-group.weight .error-message").removeClass("hide").html("Weight must not be less than or equal to 0");
      }

      var dimensionsGroup = $(".new-product").find('.dimensions input');
      dimensionsGroup.each(function (e) {
        var $dInput = $(this);
        var dVal = $dInput.val();
        if (dVal <= 0 || dVal == null || dVal == '' || dVal == undefined) {
          isValid = false;
          $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
          $errorTab = "#product-info";
          $dInput.addClass('error-input');
          $dInput.parent('.dimensions').find('.error-message.hide').html("Dimensions must not be less than or equal to 0").removeClass('hide');
        }
        else {
          var productShipmentLength = parseFloat($(".new-product").find("input[name='product[shipment_length]']").val());
          var productShipmentWidth = parseFloat($(".new-product").find("input[name='product[shipment_width]']").val());
          var productShipmentHeight = parseFloat($(".new-product").find("input[name='product[shipment_height]']").val());

          if ($dInput.attr('name') === 'product[length]') {
            if (dVal > productShipmentLength) {
              isValid = false;
              $errorTab = "#product-info";
              $dInput.addClass('error-input')
              $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
              $dInput.parent('.dimensions').find('.error-message.hide').html('product dimensions must be lesser than shipment dimensions').removeClass('hide')
            }
            else {
              $dInput.removeClass('error-input')
            }
          }
          if ($dInput.attr('name') === 'product[width]') {
            if (dVal > productShipmentWidth) {
              isValid = false;
              $errorTab = "#product-info";
              $dInput.addClass('error-input')
              $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
              $dInput.parent('.dimensions').find('.error-message.hide').html('product dimensions must be lesser than shipment dimensions').removeClass('hide')
            }
            else {
              $dInput.removeClass('error-input')

            }
          }
          if ($dInput.attr('name') === 'product[height]') {
            if (dVal > productShipmentHeight) {
              isValid = false;
              $errorTab = "#product-info";
              $dInput.addClass('error-input')
              $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
              $dInput.parent('.dimensions').find('.error-message.hide').html('product dimensions must be lesser than shipment dimensions').removeClass('hide')

            }
            else {
              $dInput.removeClass('error-input')
            }
          }

          // $(".new-product").find(".list-group .list-group-item[href='#product-info']").removeClass("error");
        }
        // else if(dVa)
        // else{
        //   console.log('hide error message 3')
        //   $dInput.removeClass('error-input');
        //   $dInput.parent('.dimensions').find('.error-message').addClass('hide');
        // }
        if ($errorTab !== "#product-info") {
          $dInput.parent('.dimensions').find('.error-message').addClass('hide');
        }
      });

      if ($errorTab !== "#product-info") {
        $(".new-product").find(".list-group .list-group-item[href='#product-info']").removeClass("error");
      }
      if (isValid) {
        if ($(".new-product").find('.dimensions input').filter(function () { return $(this).val() == ""; }).length === 0) {
          $(".new-product").find(".list-group .list-group-item[href='#product-info']").removeClass("error");
        }
        else {
        }
      }
      if (parseFloat($(".new-product").find(".input-group.shipment-weight .prod-ship-weight").val()) <= 0) {
        isValid = false;
        $(".new-product").find(".list-group .list-group-item[href='#product-info']").addClass("error");
        $errorTab = "#product-info";
        $(".new-product").find(".input-group.shipment-weight .prod-ship-weight").addClass("error-input");
        $(".new-product").find(".input-group.shipment-weight .error-message").removeClass("hide").html("Shipment weight must not be less than or equal to 0");
      }

      if (section != ".draft-inputs")
        isValid = checkDeliveryAreas(parent, isValid);
      var phoneNumberField = $("input[name='product[mobile_number]']")
      var phoneNumber = $("input[name='product[mobile_number]']").val()
      var unitCost = $("input[name='product[price]']");
      var pickUpCountry = $("select[name='product[pickup_loc_country]']");
      var pickUpProvincePh = $("select.province-select.ph");
      var pickUpProvinceCanada = $("select.province-select.canada");
      var pickUpAddress = $("input#product_address_1");
      var pickUpCity = $("input#product_city");
      var pickUpZipCode = $("input#product_zip");
      var phoneNumberPattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?|(^\+[1-9]\d{1,14}$)|(\d{9,14})$/;
      var country = $('.new-product').find("#country_product_location").val();

      if (country == 'Canada') {
        phoneNumberPattern = /^(\+?1 ?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      } else {
        phoneNumberPattern = /^(09|\+639|639)\d{9}$/;
      }
      var errorElement = $('.error-message');

      // if (unitCost <= 0) {
      //   if ($errorTab == "") {
      //     $errorTab = "#cost";
      //     $(".new-product").find(".list-group .list-group-item[href='#cost']").addClass("error");
      //   }
      //   $(".new-product").find(".list-group .list-group-item[href='#cost']").addClass("error");
      //   isValid = false
      //   errorElement.removeClass("hide")
      // }
      // // require courier fields
      // else {
      //   $(".new-product").find(".list-group .list-group-item[href='#cost']").removeClass("error");
      // }
      if (phoneNumberPattern.test(phoneNumber)) {
        // The phone number is valid

        var errorMessage = phoneNumberField.closest('.error-message');
        errorMessage.addClass("hide");
        $("input[name='product[mobile_number]']").removeClass('error-input');
      } else {
        // The phone number is not valid
        console.log('user country', user_country)
        if (user_country != 'philippines') {
          if (phoneNumber.length == 0) {
            var errorMessage = phoneNumberField.closest('.col-md-10').find('.error-message');
            errorMessage.removeClass("hide").html("Mobile number required");
            $("input[name='product[mobile_number]']").addClass('error-input');
            isValid = false
            $errorTab = "#availability";
            $(".new-product").find(".list-group .list-group-item[href='#availability']").addClass("error");
          }
          else {
            var errorMessage = phoneNumberField.closest('.col-md-10').find('.error-message');
            $(".new-product").find(".list-group .list-group-item[href='#availability']").addClass("error");
            errorMessage.removeClass("hide").html("Invalid input");
            $("input[name='product[mobile_number]']").addClass('error-input');
            isValid = false
            $errorTab = "#availability";
          }
        }
      }
      if (($.trim(pickUpProvinceCanada.val()) !== "" && pickUpProvinceCanada !== null || pickUpProvinceCanada != 'select_province') && (pickUpProvincePh.val() === 'select_province' || $.trim(pickUpProvincePh.val()) === null || pickUpProvincePh.val() === '')) {
        pickUpProvincePh.val(pickUpProvinceCanada.val())
        pickUpProvincePh.attr('value', pickUpProvinceCanada.val())
        var phOption = pickUpProvincePh.find('option[value="' + pickUpProvinceCanada.val() + '"]');
        if (phOption.length === 0) {
          pickUpProvincePh.append($('<option>', {
            value: pickUpProvinceCanada.val(),
            text: pickUpProvinceCanada.val(),
            selected: true,
          }));
        } else {
          // Option exists, set it as selected
          phOption.prop('selected', true);
        }
        var option = pickUpProvincePh.find('option[value="' + pickUpProvinceCanada.val() + '"]');
        option.attr('hidden')
        option.prop('hidden', true)
      }
      else {
        pickUpProvinceCanada.val($(this).val())
        pickUpProvinceCanada.attr('value', $(this).val())
        var canadaOption = pickUpProvinceCanada.find('option[value="' + pickUpProvincePh.val() + '"]');
        if (canadaOption.length === 0) {
          pickUpProvinceCanada.append($('<option>', {
            value: pickUpProvincePh.val(),
            text: pickUpProvincePh.val(),
            selected: true,
          }));
        } else {
          // Option exists, set it as selected
          canadaOption.prop('selected', true);
        }
        var option = pickUpProvinceCanada.find('option[value="' + pickUpProvincePh.val() + '"]');
        option.attr('hidden')
        option.prop('hidden', true)
      }
      if (user_country != 'philippines') {
        if ($.trim(pickUpCountry.val()) == "" || pickUpCountry.val() == 'select_country') {

          $errorTab = "#availability";
          isValid = false;
          var errorMessage = pickUpCountry.closest('.col-md-10').find('.error-message');
          pickUpCountry.addClass('error-input')
          errorMessage.removeClass("hide").html('Country is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        }
        else {
          var errorMessage = pickUpCountry.closest('.col-md-10').find('.error-message');
          pickUpCountry.removeClass('error-input')
          errorMessage.addClass("hide").html('');
        }
        if ($.trim(pickUpAddress.val()) == "") {

          $errorTab = "#availability";
          isValid = false;
          pickUpAddress.addClass('error-input')
          var errorMessage = pickUpAddress.closest('.col-md-10').find('.error-message');
          errorMessage.removeClass("hide").html('Address is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        }
        else {
          var errorMessage = pickUpAddress.closest('.col-md-10').find('.error-message');
          pickUpAddress.removeClass('error-input')
          errorMessage.addClass("hide").html('');
        }
        if ($.trim(pickUpProvincePh.val()) == "" || pickUpProvincePh.val() == 'select_province') {

          $errorTab = "#availability";
          isValid = false;
          pickUpProvinceCanada.addClass('error-input')
          pickUpProvincePh.addClass('error-input')
          var errorMessage = pickUpProvincePh.closest('.col-md-10').find('.error-message');
          errorMessage.removeClass("hide").html('Province is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        } else {
          var errorMessage = pickUpProvincePh.closest('.col-md-10').find('.error-message');
          pickUpProvincePh.removeClass('error-input')
          pickUpProvinceCanada.removeClass('error-input')
          errorMessage.addClass("hide").html('');
        }
        if ($.trim(pickUpProvinceCanada.val()) == "" || pickUpProvinceCanada.val() == 'select_province') {

          $errorTab = "#availability";
          isValid = false;
          pickUpProvincePh.addClass('error-input')
          pickUpProvinceCanada.addClass('error-input')
          var errorMessage = pickUpProvinceCanada.closest('.col-md-10').find('.error-message');
          errorMessage.removeClass("hide").html('Province is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        }
        else {
          pickUpProvincePh.removeClass('error-input')
          pickUpProvinceCanada.removeClass('error-input')
          var errorMessage = pickUpProvinceCanada.closest('.col-md-10').find('.error-message');
          errorMessage.addClass("hide").html('');
        }
        if ($.trim(pickUpCity.val()) == "" || pickUpCity.val() === null || pickUpCity.val().length <= 0 || pickUpCity.val() == undefined) {

          $errorTab = "#availability";
          isValid = false;
          pickUpCity.addClass('error-input')
          var errorMessage = pickUpCity.closest('.col-md-10').find('.error-message');
          errorMessage.removeClass("hide").html('City is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("active error");
        }
        else {
          var errorMessage = pickUpCity.closest('.col-md-10').find('.error-message');
          pickUpCity.removeClass('error-input')
          errorMessage.addClass("hide").html('');
        }
        if ($.trim(pickUpZipCode.val()) == "") {

          $errorTab = "#availability";
          pickUpZipCode.addClass('error-input')
          var errorMessage = pickUpZipCode.closest('.col-md-10').find('.error-message');
          isValid = false;
          errorMessage.removeClass("hide").html('Zip code is required');
          $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        }
        else {
          var errorMessage = pickUpZipCode.closest('.col-md-10').find('.error-message');
          pickUpZipCode.removeClass('error-input')
          errorMessage.addClass("hide").html('');
        }
      }
      return isValid;
    }

    function validatePhoneNumber(parent, section) {
      var isValid = true;
      var phoneNumberField = $("input[name='product[mobile_number]']")
      var phoneNumber = $("input[name='product[mobile_number]']").val()
      var errorElement = $('.error-message');
      var phoneNumberPattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?|(^\+[1-9]\d{1,14}$)|(\d{9,14})$/;
      var country = $('.new-product').find("#country_product_location").val();

      if (country == 'Canada') {
        phoneNumberPattern = /^(\+?1 ?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      } else {
        phoneNumberPattern = /^(09|\+639|639)\d{9}$/;
      }

      if (phoneNumberPattern.test(phoneNumber)) {
        // The phone number is valid

        var errorMessage = phoneNumberField.closest('.col-md-10').find('.error-message');
        errorMessage.addClass("hide");
      } else {
        // The phone number is not valid
        if (phoneNumber.length == 0) {

          var errorMessage = phoneNumberField.closest('.col-md-10').find('.error-message');
          errorMessage.removeClass("hide").html("Mobile number required");
          isValid = false
          $errorTab = "#availability";
        }
        else {

          errorElement.removeClass("hide").html("Invalid input");
          isValid = false
          $errorTab = "#availability";
        }
      }
      return isValid;
    }
    $("input[name='product[price]']").on("change", function () {
      var $costInput = $(".new-product").find(".product-price")

      if ($costInput.val() <= 0) {
        $(".new-product").find('#product-price-error-field.error-message').removeClass("hide")
        $(".new-product").find('#product-price-error-field.error-message').html("Cost must be greater than 0")

      }
      else if ($costInput.val().length <= 0) {

        $(".new-product").find('#product-price-error-field.error-message').addClass('hide')
      }
      else {

        $(".new-product").find('#product-price-error-field.error-message').addClass('hide')
      }
    })
    $("input[name='product[weight]']").on("change", function () {
      var $weightInput = $(".new-product").find(".input-group.weight .prod-weight");
      var $errorTab = "#product-info";

      if (parseFloat($weightInput.val()) <= 0) {
        $weightInput.addClass("error-input");
        $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        $(".new-product").find(".input-group.weight .error-message").removeClass("hide").html("Weight must not be less than or equal to 0");
      } else {
        $weightInput.removeClass("error-input");
        $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").removeClass("error");

        $(".new-product").find(".input-group.weight .error-message").addClass("hide").html("");
      }
    });
    $("input[name='product[shipment_weight]']").on("change", function () {

      var $shipmentWeightInput = $(".new-product").find(".input-group.shipment-weight .prod-ship-weight");
      var $errorTab = "#product-info";

      if (parseFloat($shipmentWeightInput.val()) <= 0) {
        $shipmentWeightInput.addClass("error-input");
        $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").addClass("error");
        $(".new-product").find(".input-group.shipment-weight .error-message").removeClass("hide").html("Shipment weight must not be less than or equal to 0");
      } else {
        $shipmentWeightInput.removeClass("error-input");
        $(".new-product").find(".list-group .list-group-item[href='" + $errorTab + "']").removeClass("error");

        $(".new-product").find(".input-group.shipment-weight .error-message").addClass("hide").html("");
      }
    });

    // $("select[name='product[shipment_unit_measure]']").on("change", updateDimensionLabels);
    function checkImagesOnEdit(parent, $isValid) {

      var $isImageValid = false;
      parent.find(".image-info .error-message").addClass("hide");
      parent.find(".image-info .error-message").html("");
      $(".new-product.edit-product").find(".list-group .list-group-item[href='#images']").removeClass("error");

      parent.find(".image-info .row.product-row:not(.clone, .tabs)").each(function () {
        var $imageRow = $(this);

        if ($imageRow.find(".image").attr("src") != "/assets/add-image-33d75e64408a6084259d6d279ee9d681c899fd070ba03b4a6a092410bfc6119a.png" && $imageRow.find(".image").attr("src") != "/assets/no-video-451ca6acca0005eff5042a576fe7066800d03e1e1d41ae21b4b83c3c7fbef1e9.png") {

          $isValid = true;
          $isImageValid = true;
          parent.find(".image-info .error-message").addClass("hide");
        }
      });

      if (!$isImageValid) {
        $isValid = false;
        if ($errorTab == "") {
          $errorTab = "#images";
        }
        $(".new-product.edit-product").find(".list-group .list-group-item[href='#images']").addClass("error");
        parent.find(".image-info .error-message").removeClass("hide");
        parent.find(".image-info .error-message").html("Must have at least one(1) image uploaded");
      }
      return $isValid;
    }

    function checkImages(parent, $isValid) {

      var $isImageValid = false;
      parent.find(".image-info .error-message").addClass("hide");
      parent.find(".image-info .error-message").html("");
      $(".new-product").find(".list-group .list-group-item[href='#images']").removeClass("error");

      parent.find(".image-info .row.product-row:not(.clone, .tabs)").each(function () {
        var $imageRow = $(this);
        if ($imageRow.find(".image").attr("src") != "/assets/no-image.png") {
          $isImageValid = true;
        }
      });

      if (!$isImageValid) {
        $isValid = false;
        if ($errorTab == "") {
          $errorTab = "#images";
        }
        $(".new-product").find(".list-group .list-group-item[href='#images']").addClass("error");
        parent.find(".image-info .error-message").removeClass("hide");
        parent.find(".image-info .error-message").html("Must have at least one(1) image uploaded");
      }

      return $isValid;
    }
    function checkUnitCost(parent, $isValid) {
      var $costInput = $(".new-product").find(".product-price")

      console.log('cost changed', $costInput.val())
      if ($costInput.val() <= 0) {
        $errorTab = "#cost"
        $(".new-product").find('#product-price-error-field.error-message').removeClass("hide")
        $(".new-product").find(".product-price").addClass('error-input')
        $(".new-product").find('#product-price-error-field.error-message').html("Cost must be greater than 0")
        console.log('invalid unit cost: cost must be greater than 0')
        $isValid = false;
      }
      else if ($costInput.val().length <= 0) {

        $(".new-product").find('#product-price-error-field.error-message').addClass('hide')
        $isValid = false;
      }
      else {

        $(".new-product").find('#product-price-error-field.error-message').removeClass('hide')

        $(".new-product").find(".product-price").removeClass('error-input')
        $isValid = true;
      }
      if ($isValid) {
        $(".new-product").find(".list-group .list-group-item[href='#cost']").removeClass("error");

      } else {
        $(".new-product").find(".list-group .list-group-item[href='#cost']").addClass("error");

      }
      return $isValid
    }



    function checkDeliveryAreas(parent, $isValid) {
      var currency = $(".new-product").find(".select-currency").val()
      if (currency !== 'C$') {
        if (parent.find(".delivery-info .template-locations .location-container").length == 0) {
          $isValid = false;
          if ($errorTab == "") {
            $errorTab = "#delivery";
          }
          $(".new-product").find(".list-group .list-group-item[href='#delivery']").addClass("error");
          parent.find(".delivery-info .error-message").removeClass("hide");
          parent.find(".delivery-info .error-message").html("Must have at least one(1) delivery area selected");

        }
      }
      return $isValid;
    }


    function setPreviewImage(popup, src, ctr, isMain = false, isVideo = false) {
      var $image = popup.find(".main-image.clone").clone();
      var $subImage = popup.find(".images-container .image.clone");
      if (isVideo) {
        $image = popup.find(".video.clone").clone();
        $image.removeClass('clone');
        $image.addClass('main-image');
        $image.addClass("product-" + ctr);
        $image.find('source').attr('src', src);
        $image.find('video').attr("controls", true);
        $image.appendTo(popup.find('.main-images-container'));

        // src = popup.find('.images-container .no-video-img').attr('src');
        $subImage = popup.find(".video.clone").clone();
        $subImage.addClass('image sub');
        $subImage.find('source').attr('src', src);
      } else {
        $image.attr("style", "background-image:url(" + src + ")");
        $image.removeClass("clone");
        $image.addClass("product-" + ctr);
        $image.appendTo(popup.find(".main-images-container"));

        $subImage = $subImage.clone();
        $subImage.attr("style", "background-image:url(" + src + ")");
      }

      $subImage.removeClass("clone hide");
      $subImage.attr("imageId", ctr)
      $subImage.appendTo(popup.find(".sub-images-container"));

      if (isMain) {
        $image.removeClass("hide");
        $subImage.addClass("active");
      }
    }

    function fetchTemplate(tempId) {
      $.ajax({
        type: "GET",
        url: "/delivery-services/" + tempId + ".js",
        data: { "type": "seller-template" },
        success: function (result) {
          if (result.status == 200) {
            var $template = result.template;
            $(".cities-container input[name='template[id]']").val($template.id);
            $(".delivery-type").val($template.delivery_type).change();
            $(".cities-container .template-locations").html("");
            var city_arr = [];
            if (result.cities.length > 0) {
              $.each(result.cities, function (index, loc) {
                var args = {
                  id: loc.id,
                  price: loc.price
                }
                onDeliverySelect($(".new-product"), loc.city, args);
                city_arr.push(loc.city);
              });
            }
            $(".delivery-select").val(city_arr);
          }
          else {
            console.log(result.error)
          }
        }
      });
    }

    function checkButtons(parent) {
      parent.find(".btn-next, .btn-back").removeClass("disabled");
      parent.find(".btn-next").removeClass("disabled hide");
      parent.find(".btn-save").addClass("hide");
      if ($curTab == "#product-info")
        parent.find(".btn-back").addClass("disabled");
      else if ($curTab == "#reviews" || $curTab == "#taxation") {
        parent.find(".btn-next").addClass("disabled hide");
        parent.find(".btn-save").removeClass("hide");
      }
    }

    function checkFileSize(file, maxSize) {
      var size = file.files[0].size;
      var mb = 0;
      var k = 1024;
      var m = 1000;
      var compare = k * m;
      mb = size / compare;

      return (mb > maxSize);
    }

    function readURL(input, image, isVideo = false) {
      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          if (isVideo) {
            image.removeClass("hide");
            image.html('<video style="width: 100%; height: 100%;" controls><source src="' + e.target.result + '" type="video/mp4" /></video>');
          }
          else {
            image.attr('src', e.target.result);
          }
          // $("#createCategory").find(".image-container").removeClass("hide");
          // $("#createCategory").find(".image-button").addClass("hide");
        }

        reader.readAsDataURL(input.files[0]);
      }
    }
  }

  if ($(".admin-products").length) {
    $(".admin-products").on("keypress", ".search-field", function (e) {
      if (e.key == "Enter") {
        var search_text = $(this).val();
        var url = "/products.js" + (search_text != "" ? "?search=" + search_text : "");

        $.ajax({
          type: "GET",
          url: url,
          data: { "type": "admin-dashboard" },
          success: function (result) {
          }
        });
      }
    });

    var $block = "";
    $(".admin-products").on("click", ".block-product", function () {
      $block = "blocked";
      $("#blockProduct").find(".modal-title").html("BLOCK PRODUCT");
      $("#blockProduct").find(".block-btn, .block-question, .question-row").removeClass("hide");
      $("#blockProduct").find(".unblock-btn, .unblock-question").addClass("hide");
      $("#blockProduct").find(".block-btn").attr("prodId", $(this).attr("prodId"));
    });

    $(".admin-products").on("click", ".unblock-product", function () {
      $block = "active";
      $("#blockProduct").find(".modal-title").html("UNBLOCK PRODUCT");
      $("#blockProduct").find(".block-btn, .block-question").addClass("hide");
      $("#blockProduct").find(".unblock-btn, .unblock-question, .question-row").removeClass("hide");
      $("#blockProduct").find(".unblock-btn").attr("prodId", $(this).attr("prodId"));
    });

    $("#blockProduct").on("click", ".block-btn, .unblock-btn", function () {
      var $this = $(this);
      var $popup = $(this).parents(".modal-body");
      var $prodId = $this.attr("prodId");
      var $form = $popup.find("form");
      $popup.find(".whirl").removeClass("hide");
      $popup.find("button.close").css("visibility", "hidden");
      $popup.find(".message-row, .message").removeClass("hide");

      $.ajax({
        type: "PUT",
        url: "/sellers/products/" + $prodId + "/block",
        data: { status: $block },
        success: function (result) {
          $popup.find("button.close").css("visibility", "visible");
          $popup.find(".whirl").addClass("hide");
          if (result.status == 200) {
            $popup.find(".main-buttons-row").addClass("hide");
            $popup.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $popup.find(".message-row .message").html(result.message);
          }
          else {
            $popup.find(".message-row, .error").removeClass("hide");
            $popup.find(".message-row .error").html(result.error);
          }
        }
      })
    });

    $("#blockProduct").on("click", ".btn-confirm", function () {
      window.location.reload();
    });
  }

  // if ($(".edit-product").length) {
  //   $(".edit-product").on("change", ".delivery-select", function () {
  //     var $val = $(this).val();
  //     console.log("EDIT PRODUCTT");
  //     onDeliverySelect($(".edit-product"), $val);
  //   });

  //   // $(".edit-product").on("click", ".btn-draft", function(e){
  //   //   e.preventDefault();
  //   //   var $product = $(".edit-product");
  //   //   var $form = $product.find("#product-info");

  //   //   $.ajax({
  //   //     type: "PUT",
  //   //     url:  "/sellers/products/save_as_draft",
  //   //     data:  new FormData($form[0]),
  //   //     contentType: false,
  //   //     cache: false,
  //   //     processData: false,
  //   //     success: function (result){
  //   //       if(result.status == 200){
  //   //         console.log(result.message);
  //   //       }
  //   //       else {
  //   //         console.log(result.error);
  //   //       }
  //   //     }
  //   //   });
  //   // });
  // }

  if ($(".homepage-product-detail").length) {
    var $homepage = $(".homepage-product-detail");
    var $lists = $('.countrypicker');

    $(document).on("click", ".countrypicker", function (e) {
      e.stopPropagation();
      var $tgt = $(e.target);
      $(this).find('ul').slideToggle('fast');
    });

    $(document).on("click", ".countrypicker ul li", function (e) {
      $lists.find(".span .flag").addClass("hide");
      $lists.find(".span .flag." + $(this).attr("val")).removeClass("hide");
    });

    $(document).on("click", ".search-button-mobile", function () {
      var $searchText = $(".search-container").find(".search-text");
      $searchText.toggleClass("opened");
    });

    $(".search-container").on("keypress", ".search-text", function (e) {
      var search_text = $(this).val();
      if (search_text != "")
        window.location.href = "/?search=" + search_text;
    });
    $(".search-container").on("click", ".search-button", function () {
      var search_text = $(".search-container").find(".search-text").val();
      if (search_text != "")
        window.location.href = "/?search=" + search_text;
    });

    $homepage.on("click", ".sub-images-container .image", function () {
      $homepage.find(".sub-images-container .image").removeClass("active");
      $(this).addClass("active");
      var $imgId = $(this).attr("imageId");
      $homepage.find(".main-image").addClass("hide");
      $homepage.find(".main-image.product-" + $imgId).removeClass("hide");
    });

    $homepage.on("click", ".btn.minus", function () {
      $homepage.find('.quantity-input').val(function (i, oldval) {
        if (oldval > 1) {
          --oldval;
          $homepage.find(".display-quantity").html(oldval);
        }
        return oldval;
      }).change();
    });
    var $max = parseInt($homepage.find(".btn.plus").attr("max"));
    $homepage.on("click", ".btn.plus", function () {
      $homepage.find('.quantity-input').val(function (i, oldval) {
        if ($max > oldval) {
          ++oldval;
          $homepage.find(".display-quantity").html(oldval);
        }
        return oldval;
      }).change();
    });

    $homepage.on("click", ".btn-notify", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      let $emailContainer = $homepage.find(".email-container");
      $emailContainer.find(".error, .message").html("").addClass("hide");
      let $val = $emailContainer.find(".email-address").val();
      if ($val.trim() != "") {
        if (checkEmailFormat($val)) {
          $.ajax({
            type: "PUT",
            url: "/products/notify",
            data: { prodId: $prodId, email: $val },
            success: function (result) {
              if (result.status == 200) {
                $emailContainer.find(".message").html(result.message).removeClass("hide");
              }
              else {
                $emailContainer.find(".error").html(result.error).removeClass("hide");
              }
            },
            error: function (result) {
            }
          });
        }
        else {
          $emailContainer.find(".error").html("* Invalid email format").removeClass("hide");
        }
      }
    });
  }

  if ($(".seller-products").length) {
    $(".seller-products").on("click", ".unpublish", function () {
      $("#unpublishProduct").find(".modal-title").html("UNPUBLISH PRODUCT");
      $("#unpublishProduct").find(".unpublish-btn, .unpublish-question, .question-row").removeClass("hide");
      $("#unpublishProduct").find(".publish-btn, .publish-question").addClass("hide");
      $("#unpublishProduct").find(".unpublish-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#unpublishProduct").find(".unpublish-btn").attr("prodId", $(this).attr("prodId"));
    });

    $(".seller-products").on("click", ".publish", function () {
      $("#unpublishProduct").find(".modal-title").html("PUBLISH PRODUCT");
      $("#unpublishProduct").find(".unpublish-btn, .unpublish-question").addClass("hide");
      $("#unpublishProduct").find(".publish-btn, .publish-question, .question-row").removeClass("hide");
      $("#unpublishProduct").find(".publish-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#unpublishProduct").find(".publish-btn").attr("prodId", $(this).attr("prodId"));
    });

    $("#unpublishProduct").on("click", ".unpublish-btn", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      var $content = $(this).parents(".reject-content");
      $content.find(".loading-div").removeClass("hide");
      $content.find(".main-buttons-row").addClass("hide");
      $.ajax({
        type: "PUT",
        url: "/sellers/" + $sellerId + "/products/" + $prodId + "/unpublish",
        success: function (result) {

          $content.find(".loading-div, .question-row").addClass("hide");
          if (result.status == 200) {
            $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $content.find(".message-row .message").html(result.message);
          }
          else {
            $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
            $content.find(".message-row .error").html(result.error)
          }
        },
        error: function (result) {
        }
      });
    });

    $("#unpublishProduct").on("click", ".publish-btn", function () {
      var $sellerId = $(this).attr("sellerId");
      var $prodId = $(this).attr("prodId");
      var $content = $(this).parents(".reject-content");
      $content.find(".loading-div").removeClass("hide");
      $content.find(".main-buttons-row").addClass("hide");
      $.ajax({
        type: "PUT",
        url: "/sellers/" + $sellerId + "/products/" + $prodId + "/publish",
        success: function (result) {

          $content.find(".loading-div").addClass("hide");
          if (result.status == 200) {
            console.log('call publish')
            $("#unpublishProduct").find(".publish-btn, .publish-question").addClass("hide");
            $content.find(".publish-question").addClass('hide');
            $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
            $content.find(".message-row .message").html(result.message);
          }
          else {
            $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
            $content.find(".message-row .error").html(result.error)
          }
        },
        error: function (result) {
        }
      });
    });

    $("#unpublishProduct").on("click", ".btn-confirm", function () {
      window.location.reload();
    });

    $(".seller-products").on("click", ".btn-discard", function () {
      $("#discardProduct").find(".discard-btn").attr("sellerId", $(this).attr("sellerId"));
      $("#discardProduct").find(".discard-btn").attr("prodId", $(this).attr("prodId"));
    });

    $("#discardProduct").on("click", ".discard-btn", function () {
      var title = $(this).html();
      console.log(title);

      if (title === 'Discard') {
        var $sellerId = $(this).attr("sellerId");
        var $prodId = $(this).attr("prodId");
        var $content = $(this).parents(".reject-content");
        $content.find(".loading-div").removeClass("hide");
        $content.find(".main-buttons-row").addClass("hide");
        $.ajax({
          type: "PUT",
          url: "/sellers/" + $sellerId + "/products/" + $prodId + "/discard",
          success: function (result) {

            $content.find(".loading-div").addClass("hide");
            if (result.status == 200) {
              $content.find(".discard-question").addClass("hide")
              $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
              $content.find(".message-row .message").html(result.message);
            }
            else {
              $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
              $content.find(".message-row .error").html(result.error)
            }
          },
          error: function (result) {
          }
        });
      } else {
        var prodIDs = $(".delete-all-products").attr('productIDs');
        var $content = $(this).parents(".reject-content");
        $content.find(".loading-div").removeClass("hide");
        $content.find(".main-buttons-row").addClass("hide");

        $.ajax({
          type: "POST",
          url: "/sellers/products/multiple_delete",
          data: { "product_ids": prodIDs.split(',') },
          success: function (result) {
            console.log("RESULTTT", result);
            $content.find(".loading-div").addClass("hide");
            if (result.status == 200) {
              $content.find(".discard-question").addClass("hide")
              $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
              $content.find(".message-row .message").html(result.message);
            }
            else {
              $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
              $content.find(".message-row .error").html(result.error)
            }
          },
          error: function (result) {
          }
        });
      }

    });

    $("#discardProduct").on("click", ".btn-confirm", function () {
      window.location.reload();
    });

    $('[data-check-all], .checkbox').on('change', function () {
      var $table = $("#datatable1_wrapper");
      var $firstRow = $("#datatable1_wrapper .row:first-child .col-sm-12:first-child");
      var checked = $(this).find('input').prop('checked');
      var prodIDs = [];

      $table.find('[data-product-id]').each(function (e) {
        if ($(this).prop('checked')) {
          var productId = $(this).attr('data-product-id');
          if (!prodIDs.includes(productId)) {
            prodIDs.push($(this).attr('data-product-id'));
          }
        }
      });

      if ($('.delete-all-products').hasClass('hide') && checked) {
        $(".delete-all-products").removeClass('hide');
        $('.delete-all-products').attr('productIDs', prodIDs);
      } else {
        if (prodIDs.length === 0) {
          $('[data-check-all] input').prop('checked', false);
          $(".delete-all-products").addClass('hide');
        } else {
          $('.delete-all-products').attr('productIDs', prodIDs);
        }
      }
    });

    $(document).on('click', '.delete-all-products', function () {
      $('#discardProduct').find("h4").html('DELETE ALL PRODUCTS');

      var $content = $('#discardProduct').find(".reject-content");
      $content.find('.discard-question').html('Are you sure to delete all products?');
      $content.find('.discard-btn').html('Delete');
    });
  }

  function onRemoveCity($parent) {
    if ($parent.attr("cityId") != "" || $parent.attr("cityId") != undefined) {
      $('<input>').attr({
        type: 'hidden',
        name: 'remove_city_ids[]',
        value: $parent.attr("cityId")
      }).appendTo($(".remove-city-ids-container"));
    }
    $parent.remove();
  }

  function onDeliverySelect(parent, $val, args = null) {
    console.log('args:', args);
    if (parent.find(".location-container[city_name='" + $val + "']").length == 0) {
      var $place;
      if (args === 'branches') {
        $place = parent.find(".branches.location-container.clone.hide").clone();
      }
      else {
        $place = parent.find(".provinces.location-container.clone.hide").clone();
      }

      $place.removeClass("hide clone");
      $place.attr("city_name", $val);
      $place.find(".location").html($val);
      $place.find(".input-name").attr("name", "template[cities][][city]");
      $place.find(".input-name").val($val);
      $place.find(".currency-text").html($(".new-product").find(".select-currency").val());
      $place.find(".input-currency").attr("name", "template[cities][][currency]").val($(".new-product").find(".select-currency").val());
      $place.find(".input-price").attr("name", "template[cities][][price]");
      $place.find(".input-price").attr("placeholder", "0.00");
      $place.find(".input-price").addClass("regex");
      if (args != null) {
        $place.find(".input-price").val(args["price"]);
        $('<input>').attr({
          type: 'hidden',
          name: 'template[cities][][id]',
          value: args["id"]
        }).appendTo($place);
      }
      if (args == 'branches') {
        console.log('appending to branches container');
        $place.appendTo(parent.find(".branches-container .template-locations.branches"));
      }
      else {
        console.log('appending to provinces container');
        $place.appendTo(parent.find(".provinces-container .template-locations.provinces"));
      }

      $(".input-price.regex").on("keypress", function (e) {
        var test = /[0-9.\b]/
        var value = String.fromCharCode(e.keyCode);
        console.log('key pressed');
        if (!value.match(test)) {
          console.log('regex test failed', test);
          return false;
        }
      });
    }
    $(document).on('keypress', ".location-container:not(.clone) .input-price", function (e) {
      var test = /[0-9.\b]/;
      var value = String.fromCharCode(e.keyCode);
      console.log('key pressed')
      if (!value.match(test)) {
        console.log('regex test failed', test)
        return false;
      }
    });
  }

  function formatState(state) {
    if (!state.id) {
      return state.text;
    }
    var $state = $(
      '<span class="' + state.title + '" >' + state.text + '<em class="fa fas fa-plus"></em><em class="fa fas fa-minus"></em></span>'
    );
    console.log('format state')
    return $state;
  };

  function formatSelection(state) {
    if (!state.id) {
      return state.text;
    }

    var $state = $(
      '<span></span>'
    );

    $state.find("span").remove();
    console.log('format selection')
    return $state;
  };
  function checkEmailFormat(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }
  function showToast(message, hasTimer, duration, type) {
    $(document).find('.toaster').each(function () {
      $(this).remove();
    })

    var icon = type === 'success' ? "<i class='fa fa-check' style='color:white;padding:0 6px;'></i>" : "<i class='fa fa-exclamation' style='color:white;padding:0 6px;'></i>"
    var textcolor = type === 'success' ? 'background-color:green;color:white;opacity:1;font-size:16px;' : 'background-color:#e74c3c;color:white;opacity:1;font-size:16px;';
    var $toast = $("<div class='toaster' style='padding:10px;position:fixed;bottom:20px;right:20px;border-radius:5px;" + textcolor + "'>" + icon + message + "</div>");

    if (hasTimer) {
      $toast.addClass('timer');
      var $progressBar = $('<div class="progress-bar" style="width: 100%; height: 1.5px; background-color: #ddd;"></div>').appendTo($toast);
      var timer = duration;
      var interval = setInterval(function () {
        timer -= 100;
        var progress = (timer / duration) * 100;
        $progressBar.css('width', progress + '%');
        if (timer <= 0) {
          clearInterval(interval);
          $toast.fadeOut(300, function () {
            $toast.remove();
          });
        }
      }, 100);
    }

    $(document).find('.new-product').append($toast);
  }
});
